import {
  Locale,
  type LocalizedStrings,
  useLocalization,
} from "~/components/localization/LocalizationProvider";
import { HeroStyle2 } from "~/components/HeroStyle2";

type Localization = {
  title: string;
};

const englishLocalization: Localization = {
  title: "About Us",
};

const spanishLocalization: Localization = {
  title: "Sobre Nosotros",
};

const localized: LocalizedStrings<Localization> = {
  [Locale.EN]: englishLocalization,
  [Locale.ES]: spanishLocalization,
};

export function AboutUsHero() {
  const getLocalization = useLocalization(localized);
  return (
    <HeroStyle2
      heroImageUrl="/about-us-hero-2026.jpg"
      title={getLocalization("title")}
      backgroundPosition="50% 30%"
      marginTop="-25px"
    />
  );
}
